/**
 * Утилиты для работы с API отчётов
 */

// ==================== КОНСТАНТЫ ====================

/**
 * Задержки для загрузки отчётов (в миллисекундах)
 */
export const REPORT_LOADING_DELAYS = {
  /** Задержка применения groupsChecked, metricsChecked, totalChecked */
  DEFERRED_PARAMS: 100,
  /** Задержка перед загрузкой данных */
  DATA_FETCH: 250,
} as const;

// ==================== ОБРАБОТКА ОШИБОК ====================

/**
 * Проверяет, является ли ошибка ошибкой отмены запроса
 * @param error - объект ошибки
 * @returns true если запрос был отменён
 */
export const isAbortError = (error: any): boolean => {
  return (
    error?.name === 'AbortError' ||
    error?.name === 'CanceledError' ||
    error?.message === 'Request aborted' ||
    error?.code === 'ECONNABORTED' ||
    error?.code === 'ERR_CANCELED'
  );
};

// ==================== НОРМАЛИЗАЦИЯ ДАННЫХ ====================

export interface NormalizedGroupChecked {
  ids: string[];
  pathStr: string;
  label: string;
  [key: string]: unknown;
}

/**
 * Нормализует сохранённые groupsChecked из legacy форматов.
 * Поддерживает:
 * - Legacy формат: string[] (массив строк pathStr)
 * - Текущий формат: { ids, pathStr, label }[]
 * 
 * @param raw - сырые данные из сохранённого отчёта
 * @returns нормализованный массив groupsChecked
 */
export const normalizeSavedGroupsChecked = (raw: unknown): NormalizedGroupChecked[] => {
  if (!Array.isArray(raw)) return [];
  
  // Legacy формат: string[]
  if (raw.every((x) => typeof x === 'string')) {
    return (raw as string[])
      .filter(Boolean)
      .map((pathStr) => ({ ids: [pathStr], pathStr, label: pathStr }));
  }
  
  // Текущий формат: { ids, pathStr, label }[]
  return (raw as any[])
    .filter((x) => x && typeof x === 'object')
    .map((x) => {
      const pathStr = typeof x.pathStr === 'string' ? x.pathStr : '';
      const ids = Array.isArray(x.ids) ? x.ids : pathStr ? [pathStr] : [];
      const label =
        typeof x.label === 'string'
          ? x.label
          : typeof x.group === 'string'
            ? x.group
            : pathStr;
      return { ...x, ids, pathStr, label };
    })
    .filter((x) => typeof x.pathStr === 'string' && x.pathStr);
};
